module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset class="embed-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".embed-properties-accordion">Embed</legend>\n    <div class="embed-properties-accordion collapse collapse-target">\n        <div>\n            <input type="text" class="url full-width" placeholder="Add your link here&#8230;">\n            <span class="help-block">\n                Enter the URL for the content you want to embed in your Experience.\n            </span>\n            ';
 if (descriptor.type !== "url") { ;
__p += '\n            <span class="help-block">\n                <em>Embedded ' +
__e( descriptor.type ) +
'</em>: <a class="embedded">' +
__e( descriptor.id );
 if (descriptor.scene > 1) { ;
__p += ', scene ' +
__e( descriptor.scene ) +
' ';
 } ;
__p += '</a>\n            </span>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n</fieldset>\n\n<div class="animation-properties"></div>\n<fieldset class="size-and-position-properties"></fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/embedWidget/EmbedWidgetPropertiesView.tpl
// module id = 1785
// module chunks = 0